export default [{"tag":"path","att":{"d":"M16 2H8v2h1v6l-2 3v1.5h4V22h2v-7.5h4V13l-2-3V4h1V2z"}}]